<template>
  <el-dialog
    :title="$t('editChainInoutOrder.editTitle')"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('editChainInoutOrder.supplierId')" prop="csId">
        <el-input 
          v-model="form.csId" 
          :placeholder="$t('editChainInoutOrder.supplierIdPlaceholder')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateChainInoutOrder } from '@/api/goods/chainInoutOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        orderId: '',
        csId: '',
        shopId: ''
      },
      rules: {
        orderId: [
          { required: true, message: this.$t('editChainInoutOrder.orderIdRequired'), trigger: 'blur' }
        ],
        csId: [
          { required: true, message: this.$t('editChainInoutOrder.supplierIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('editChainInoutOrder.supplierIdMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.form = Object.assign({}, row)
      this.form.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await updateChainInoutOrder(this.form)
            this.$message.success(this.$t('editChainInoutOrder.updateSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('更新失败:', error)
          }
        }
      })
    }
  }
}
</script>